import type { SVGProps } from 'react';

const SvgVoteFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M18 13.0006H17.32L15.32 15.0004H17.23L19 17.0003H5L6.78 15.0004H8.83L6.83 13.0006H6L3 16.0004V20.0001C3 20.5305 3.21071 21.0392 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0392 21 20.5305 21 20.0001V16.0004L18 13.0006ZM17 7.95089L12.05 12.9006L8.5 9.3608L13.46 4.41111L17 7.95089ZM12.76 2.29124L6.39 8.66084C6 9.05082 6 9.68078 6.39 10.0708L11.34 15.0004C11.73 15.4104 12.36 15.4104 12.75 15.0004L19.11 8.66084C19.5 8.27087 19.5 7.64091 19.11 7.25093L14.16 2.30124C13.78 1.90127 13.15 1.90127 12.76 2.29124Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgVoteFilled;
